<template>
  <v-flex>
    <v-toolbar flat class="mb-4 text-xs-center">
      <v-btn icon to="/home" >
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title class="headline text-xs-center">{{msg}}</v-toolbar-title>
    </v-toolbar>
    <v-card v-if="userGroup==='ampsVoiceTrackerAdmin'" flat tile class="mb-4">
      <v-container  fluid grid-list-lg  class="my-0 py-0">
        <v-layout >
          <v-flex justify-center text-xs-left xs12>
            <v-card-text class="helpadmin" >    
            <div id="top2" class="mb-4">
            </div>
            <div id="inline1"  v-html="myHTML"  contenteditable="true"  ></div>        
            <!--
              <wysiwyg  v-model="myHTML" />
              
                <VueCkeditor id='inline1'
                v-model="myHTML"
                 :contenteditable="true" 
                 :config="ckConfig" 
                 :disableAutoInline="true"
                /> 
            -->
            </v-card-text>
          </v-flex> 
        </v-layout>
      </v-container> 
      <v-container  fluid grid-list-lg class="my-0 py-0" >
        <v-layout class="">        
           <v-flex justify-center text-xs-left xs12 class="">    
             <v-card-text class="mt-0 pt-0">                 
              <div class="text-xs-left block xs12">
                <v-alert xs12  class="" v-model="alert" type="success" dismissible>
                Help Info Page Edits Saved.
              </v-alert> 
                <v-btn class="ma-0 pa-0 block" color="primary" dark @click="saveHelpEdit(myHTML);">Save Edit</v-btn>
              </div>
              </v-card-text>
          </v-flex>
        </v-layout>
      </v-container>                  
      <v-container v-if="false" fluid grid-list-lg  class="mt-4 py-0">
        <v-layout >
          <v-flex justify-center text-xs-left xs12>
            <v-card-text>    
              <h1>Live Preview</h1>
              <div class="my-4 " v-html="myHTML"></div>
            </v-card-text>
          </v-flex> 
        </v-layout>
      </v-container>
    </v-card>
    <v-layout v-else column align-center>
      <div>
        You don't have permission to access that page.
        <router-link to="/">Click here</router-link>
          to return to the homepage.
      </div>
    </v-layout>
  </v-flex>
</template>
<script>

import UpdateActivityHelpMutation from './mutations/UpdateActivityHelpMutation';
import GetActivityHelpQuery  from './queries/GetActivityHelpQuery';
import AppConst from './AppConst.js';

var appTitleLocal = AppConst.appTitle;

function getHelpText( that, callback){
         
          that.$apollo.query({ 
                variables: {
                  id: 'HelpAdminText'
                    //actDate: localStorage.currentDate,
                    //username: localStorage.subID,         
                },
                query: GetActivityHelpQuery })
            .then(function logData(data) {
                  if(data.data.getActivityHelp!== null){
                          //check for Sick
                          if(data.data.getActivityHelp.id=='HelpAdminText'){
                              callback(data.data.getActivityHelp.notes);
                          }
                  }
            }).catch(console.error);
}



export default {
  data () {
    return { 
      msg: 'Help Page Admin',
      userGroup: localStorage.userGroup,
      appTitle: appTitleLocal,
      myHTML: '',
      alert: false,
      ckConfig: {
        //inline: 'inline1',
        disableAutoInline: true,
        extraAllowedContent: '*{*}',
        extraPlugins: 'sharedspace,sourcedialog',
        //removePlugins: 'sourcearea',
        sharedSpaces: {
          top: 'top2',
        },
        allowedContent: true,
        contentCss: [ 'https://unpkg.com/vuetify/dist/vuetify.min.css', 'https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons'],
        height: 300,
        toolbar : 'Basic',
        removeButtons: 'NewPage,Templates,Underline,Strike,Subscript,Superscript,Styles,Specialchar,TextField,Textarea,Form,Checkbox,Radio,Button,Select,ImageButton,Image,HiddenField,Flash,Font,Language',
        /*toolbarGroups: [
            { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
            { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
            { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
            { name: 'forms', groups: [ 'forms' ] },
            { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
            { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
            { name: 'links', groups: [ 'links' ] },
            { name: 'insert', groups: [ 'insert' ] },
            { name: 'styles', groups: [ 'styles' ] },
            { name: 'colors', groups: [ 'colors' ] },
            { name: 'tools', groups: [ 'tools' ] },
            { name: 'others', groups: [ 'others' ] },
            { name: 'about', groups: [ 'about' ] }
          ],
        removeButtons: 'Print,Preview,NewPage,Save,Templates,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,BidiLtr,BidiRtl,Language,Image,Flash,Iframe,PageBreak,Font,Styles,About',      
        */
      }     
    }
  },
  mounted: function(that=this)
  {
      window.CKEDITOR.disableAutoInline = true;
      window.CKEDITOR.inline('inline1', this.ckConfig );
    // From testing, without a brief timeout, it won't work.
    
    getHelpText(that, function(data){
      that.myHTML=data;
      window.CKEDITOR.instances['inline1'].setData(that.myHTML);
    });
    setTimeout(() => this.scrollFix(), 1)
  },
  methods: {
    scrollFix: function()
    {
      
      if(window.location.hash!=''){
        
        window.scrollTo(0, window.pageYOffset-100);
      }
      
    },
    saveHelpEdit: function (myHTML) {
          var that=this;
          myHTML=window.CKEDITOR.instances.inline1.getData();
          //gather inputs
          var avaInput = {
                  id: 'HelpAdminText',
                  username:  localStorage.subID,  
                  actDate: localStorage.currentDate,
                  activityType: 'HelpAdminText',
                  timestamp: ( new Date().getTime() ),
                  value: 0,
                  intensity: 'edit',
                  notes: myHTML,    
          } 
          //check if notes is an empty string, if so remove
          if(avaInput.notes==''){ delete avaInput.notes; }

          //add to dynamodb
          this.$apollo.mutate({
              variables: {
                  input: avaInput
              },
              mutation: UpdateActivityHelpMutation
          }).then(function() {
              that.alert = true;
              that.alert = true;
              setTimeout(() => that.alert=false, 6000)
          }).catch(error => console.error(error)); 
          
    },    

  }
}
 </script>
 <style scoped >
    @import "~vue-wysiwyg/dist/vueWysiwyg.css";
    #top2{
      position: sticky;
      top: 62px;
      z-index: 100;
    }
    h1{  text-transform:capitalize; margin-bottom: 12px;}
    .helpadmin:focus, .helpadmin *:focus { 
      border:none; 
      
      outline: -webkit-focus-ring-color auto 0px;
      outline-color: -webkit-focus-ring-color;
      outline-style: auto;
      outline-width: 0px;
      outline-color: none; 
    }
</style>
 <style>
    .helpadmin ul,  .helpadmin ol{ margin-left: 8px !important;     padding-left: 8px !important;}
    .helpadmin ul li, .helpadmin ol li{ margin-left: 8px !important; }

    .helpadmin .editr--toolbar {
        background: #f6f6f6;
        border-bottom: 1px solid #e4e4e4;
        position: relative;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        height: auto;
        flex-wrap: wrap;
    }
    .helpadmin .editr--toolbar a.vw-btn-separator {
        width: 1px;
        margin: 0 8px;
        display: none;
    }
 </style>



// WEBPACK FOOTER //
// src/components/HelpAdmin.vue